import { render, staticRenderFns } from "./Drink.vue?vue&type=template&id=0cd5b8a7&scoped=true&"
import script from "./Drink.vue?vue&type=script&lang=js&"
export * from "./Drink.vue?vue&type=script&lang=js&"
import style0 from "./Drink.vue?vue&type=style&index=0&id=0cd5b8a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd5b8a7",
  null
  
)

export default component.exports